import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isSupportedLanguage } from '@/i18n/config';

/**
 * Reconciles the authenticated user's stored language preference with the active
 * i18next language. The DB is the source of truth post-login; the localStorage
 * cache (set by the detector) only prevents a flash before `me` resolves.
 *
 * When the stored preference differs from the active language, switch to it -
 * which the detector also writes back to localStorage. A null/absent preference
 * leaves the browser-detected language untouched.
 */
export function useLanguageSync(preferredLanguage: string | null | undefined) {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!isSupportedLanguage(preferredLanguage)) return;
    if (i18n.language === preferredLanguage) return;
    void i18n.changeLanguage(preferredLanguage);
  }, [preferredLanguage, i18n]);
}
